import React from 'react';
import ERITrendChart from '@/components/ERITrendChart';

// Generate realistic demo data
function generateDemoData() {
  const scores = [];
  let base = 32;
  const now = new Date();

  for (let i = 24; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);

    const progress = (24 - i) * 1.8;
    const variance = Math.sin(i * 0.7) * 6 + (Math.cos(i * 1.3) * 3);
    const eri = Math.min(95, Math.max(15, base + progress + variance));
    const reg = Math.min(100, Math.max(10, eri + Math.sin(i * 0.5) * 12));
    const stab = Math.min(100, Math.max(10, eri + Math.cos(i * 0.8) * 10 - 5));
    const cons = Math.min(100, Math.max(10, eri + Math.sin(i * 0.3) * 8 + 3));

    const band = eri < 40 ? 'early' : eri < 60 ? 'emerging' : eri < 80 ? 'growing' : 'strong';

    scores.push({
      eri_score: Math.round(eri * 10) / 10,
      regulation_capacity: Math.round(reg * 10) / 10,
      stability_score: Math.round(stab * 10) / 10,
      practice_consistency: Math.round(cons * 10) / 10,
      entries_analyzed: 3 + Math.floor(Math.abs(Math.sin(i)) * 5),
      period_days: 14,
      valid_regulation_entries: 3 + Math.floor(Math.abs(Math.cos(i)) * 4),
      interpretation_band: band,
      calculated_at: date.toISOString(),
      avg_pre_activation: Math.round((5 + Math.sin(i) * 2) * 10) / 10,
      avg_post_activation: Math.round((3 + Math.cos(i) * 1.5) * 10) / 10,
      avg_regulation_delta: Math.round((2 + Math.sin(i) * 1) * 10) / 10,
    });
  }
  return scores.reverse();
}

export default function ERIPreview() {
  const demoScores = generateDemoData();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #F7F3EC 0%, #EFE7DD 50%, #B8D3CF 100%)',
      padding: '40px 20px 100px',
      display: 'flex', flexDirection: 'column', alignItems: 'center'
    }}>
      <div style={{ maxWidth: '600px', width: '100%' }}>
        <h1 style={{
          fontFamily: "'Georgia', serif",
          color: '#1E6B68', fontSize: '1.4rem',
          fontWeight: '400', margin: '0 0 8px', textAlign: 'center'
        }}>
          Emotional Regulation Index
        </h1>
        <p style={{
          color: '#999', fontSize: '0.82rem', textAlign: 'center',
          margin: '0 0 32px'
        }}>
          Preview — Demo data
        </p>

        <ERITrendChart userId={null} demoData={demoScores} />
      </div>
    </div>
  );
}
